import { ArrowLeft, ClipboardList } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import MarkdownDisplay from '../../components/Common/MarkdownDisplay';
import { PageLayout } from '../../components/Layout/PageLayout';
import { Button } from '../../components/Common/button';

const DocUseCases: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageLayout
      icon={<ClipboardList className="h-6 w-6" />}
      title={t('documentation.useCases.title')}
      subtitle={t('sidebar.documentation.root')}
      headerRight={
        <Button variant="outline" size="sm" asChild>
          <Link to="/documentation">
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('documentation.backToGuide', 'User Guide')}
          </Link>
        </Button>
      }
    >
      <MarkdownDisplay content={t('documentation.useCases.content')} />
    </PageLayout>
  );
};

export default DocUseCases;
